<template>
  <el-form>
    <el-row :gutter="24">
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <el-input
            :value="mixFiltersFields.search"
            @input="mixFiltersFields.search = valueTrimLeft($event)"
            @change="mixApplyFilter"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('employee')"
          class="material-style"
        >
          <select-response
            :model.sync="mixFiltersFields.phasePersonInChargeEmployeeID"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"
            @on-change="mixApplyFilter"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('bax-po')"
          class="material-style"
        >
          <el-input
            :value="mixFiltersFields.baxpo"
            @input="mixFiltersFields.baxpo = handlerInputBaxPo($event)"
            @change="mixApplyFilter"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('supplier')"
          class="material-style"
        >
          <div class="d-flex">
            <select-response-auto-complete
              style="flex: 1"
              templateFilter='name.StartsWith("${data.search}")'
              :model.sync="mixFiltersFields.supplierCompanyID"
              api="Companies/GetAllDynamic"
              :fields="{ id: 'id', title: 'name' }"
              @on-change="mixApplyFilter"
            ></select-response-auto-complete>
            <export-excel
              v-if="mixFiltersFields.supplierCompanyID"
              @onAll="handlerExportSupplier({ isAll: true })"
              @onCurrent="handlerExportSupplier({ isAll: false })"
            />
          </div>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('part')"
          class="material-style"
        >
          <select-response-auto-complete
            :model.sync="mixFiltersFields.partID"
            api="Parts/GetAllDynamic"
            selected="id,partNumber,partDescription,remark"
            searchAllColumns
            :columns="columnsPart"
            :fields="{ id: 'id', title: 'partNumber' }"
            @on-change="mixApplyFilter"
          ></select-response-auto-complete>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('custom-filters')"
          class="material-style"
        >
          <select-response
            :model.sync="mixFiltersFields.custom"
            :data="dataSourceCustomFilters"
            @on-change="mixApplyFilter"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xl="8" :lg="6" :span="12">
        <el-form-item
          :label="L10n('order-by')"
          class="material-style"
        >
          <activity-select-order
            :value="orderBy"
            @on-change="(id) => $emit('update:orderBy', id)"
          />
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('order-phase')"
          class="material-style"
        >
          <select-response
            :model.sync="mixFiltersFields.orderPhaseID"
            :data="dataSourceOrderPhase.records"
            :isLoading="dataSourceOrderPhase.isLoading"
            @on-change="mixApplyFilter"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xl="12" :lg="16" :span="24" >
        <el-switch
          :value="displayActivityLog"
          @change="$emit('update:displayActivityLog', $event)"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-text="L10n('display-activities-log')"
          :inactive-text="L10n('hide-activities-log')">
        </el-switch>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Filters from '@/mixins/Filters'

import { filterStartsWith, ORDER_PHASE_CLOSE } from '@/utils/shared'
import { dateDay, decoratorCondition, makeFilter } from '@/utils/dynamic'

export default {
  name: 'TopPanel',
  mixins: [Filters],
  components: {
    'export-excel': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ExportExcel'),
    'activity-select-order': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Activity/SelectOrderBy')
  },
  props: {
    displayActivityLog: { type: Boolean, required: true },
    orderBy: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.mixApplyFilter()
  },
  data () {
    return {
      mixFiltersFields: {
        search: '',
        phasePersonInChargeEmployeeID: null,
        baxpo: this.$route.query.po || '',
        supplierCompanyID: '',
        partID: '',
        custom: '',
        orderPhaseID: 'ACTIVE'
      },
      mixFiltersConfig: {
        search: {
          // eslint-disable-next-line
          template: 'rfq.customerCompany.name.contains("${data.value}")'
        },
        phasePersonInChargeEmployeeID: {
          // eslint-disable-next-line
          template: 'phasePersonInChargeEmployeeID == ${data.value}'
        },
        // eslint-disable-next-line
        supplierCompanyID: { template: "rfq2.supplierCompanyID == ${data.value}" },
        // eslint-disable-next-line
        partID: { template: 'partID == ${data.value}' },
        // eslint-disable-next-line
        custom: { template: '${data.value}' },
        orderPhaseID: {
          template: (data) => {
            if (!data.value) return ''
            if (data.value === 'ACTIVE') {
              return `orderPhaseID !=${ORDER_PHASE_CLOSE}`
            }
            return `orderPhaseID=="${data.value}"`
          }
        }
      }
    }
  },
  computed: {
    dataSourceOrderPhase () {
      const res = this.API('OrderPhases/GetAllDynamic?select=id,title&orderBy=title')
      return { ...res, records: [{ id: 'ACTIVE', title: this.L10n('active') }, ...res.records] }
    },
    dataSourceCustomFilters () {
      return [
        { id: 'orderPhaseID==20', title: this.L10n('urgent') },
        { id: 'rfq2.estimatedDeliveryDate == null', title: this.L10n('missing-edd') },
        { id: false, title: this.L10n('delivery-date-past') },
        { id: makeFilter('rfq2.estimatedDeliveryDate', new Date(), decoratorCondition(dateDay)), title: this.L10n('edd-is-today') },
        { id: makeFilter('reminderDate', new Date(), decoratorCondition(dateDay)), title: this.L10n('reminder-is-today') }
      ]
    },
    columnsPart () {
      return [
        { title: this.L10n('part-number'), value: 'partNumber', originField: 'partNumber', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('part-description'), value: 'partDescription', originField: 'partDescription', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('remark'), value: 'remark' }
      ]
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&OrderBy=name')
    }
  },
  methods: {
    mixHookOnFilter (filterValue) {
      this.$bus.$emit('open-wo-on-filter', filterValue)
    },
    handlerInputBaxPo (value) {
      let result = String(value).replace(/^w/ig, '')
      return result
    },
    handlerExportSupplier ({ isAll }) {
      this.$bus.$emit('export-supplier', { isAll })
    }
  }
}
</script>
